import styled from 'styled-components';
import Colors from 'constants/Colors';
import { SemiBoldText } from 'components/Text';

const Wrapper = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 40px; 
  background-color: ${Colors.GRAY[8]};
  background-color-primary: ${Colors.PRIMARY};
  background-color-test: orange;
  z-index: 1000;

  @media screen and (max-width: 768px) {
    margin-top: 2rem;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  max-width: 100vw;
  margin: 0 auto;
  padding: 0px 20px;
  @media (max-width: 1200px) {
    padding: 0px 20px 0px 20px;
  }
`;

const Logo = styled.img`
  max-width: 120px;

`;

const Website = styled(SemiBoldText)`
  color: ${Colors.GRAY[6]};
  margin-left: 15vw;
  font-size: 16px;
`;

export { Wrapper, Container, Logo, Website };
